// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "chunks/" + chunkId + "." + {"344":"4fd96066fff21a1d60fd","774":"9ba43b4131f5c2ed6313"}[chunkId] + ".js";
};